import { API } from 'aws-amplify';

interface Paper {
  title: string;
  summary: string;
  published: string;
  link: string;
  authors: string[];
}

export interface SearchParams {
    keywords?: string;
    yearFrom?: string;
    yearTo?: string;
}

export const fetchArxivFeeds = async (searchParams?: SearchParams): Promise<Paper[]> => {
    try {
        const queryParams = searchParams ? {
            queryStringParameters: searchParams
        } : {};
        
        const response = await API.get('apilambda1', '/search', queryParams);
        return response;
    } catch (error) {
        console.error('Error fetching from Lambda API:', error);
        throw error;
    }
};

